import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import usePrintable from '@/composables/printable/printable';
import useSidebarSvc from '@/composables/logged-in-user/side-bar';
import useSnackBar from '@/composables/snackbar';
import { computed, ref } from 'vue';
import { downloadFromURL } from 'shared/lib/file-download';
import { logCatch } from '@/lib/logger/logger';
import { printableStatus } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

export default function usePageExport() {
  const { loggedInUser } = useLoggedInUser();
  const { containerWidth } = useSidebarSvc(loggedInUser);
  const snackBar = useSnackBar();

  const { t } = useI18n();

  const route = useRoute();
  const isPrint = computed(() => {
    if (route === undefined) {
      return false;
    }
    return route.query.print !== undefined;
  });

  const printableSvc = usePrintable();
  const exportLoading = ref(false);
  const exportPage = (printable) => {
    exportLoading.value = true;
    return printableSvc.createSingle({ ...printable, localStorage: JSON.stringify(localStorage), creator: { uid: loggedInUser.value.uid }, width: containerWidth.value }).then(async (data) => {
      if (data.status !== printableStatus.done) {
        exportLoading.value = false;
        snackBar.error(t('error.pageExport'));
        return;
      }
      await downloadFromURL(data.storageObject.fileName, data.storageObject.getURL);
      exportLoading.value = false;
    }).catch(logCatch(() => {
      exportLoading.value = false;
      snackBar.error(t('error.pageExport'));
    }));
  };
  return { isPrint, exportPage, exportLoading };
}
